import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { LocationComponent } from '@app/features/locations/modules/location/location.component';
import { Authority } from '@app/shared/utils/enums';

export const locationRoutes: Routes = [
    {
        path: 'location',
        children: [
            {
                path: '',
                component: LocationComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]